import { useRouteMatch } from 'react-router-dom';

import { EXTERNAL_GEO_EVENT_DETAILS_ROUTE_PATH } from '../../../../constants';

export const useSelectedExternalGeoEventId = (): string | undefined => {
  const match = useRouteMatch<{ externalGeoEventId: string }>({
    path: EXTERNAL_GEO_EVENT_DETAILS_ROUTE_PATH,
    exact: true,
  });
  return match?.params.externalGeoEventId;
};
